<div class="warning-message-bg">
    <span class="warning-text">{{configData.warningText.textValue}}</span>
    <button class="warning-close" mat-icon-button (click)="closeWarningFn()">
         <div class="material-icons material-icon-color">close</div>
    </button>
</div>